module.exports = __webpack_public_path__ + "img/thumbnail_SussexChicken_j_erythristic.84a101dc.png";